module.exports = __webpack_public_path__ + "static/img/NZZF.6c96847e.svg";